import { IconButton, Tooltip } from "@mui/material";
import { EyeIcon } from "../../../components/Icons";
import CambiosEvento from "../../../screens/Admin/Auditoria/CambiosEvento";

export const eventosActasTableData = (data, getEventSelect, getActaDetalle) => {
  const columns = [
    { field: "id", headerName: "ID", hide: false },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      sortable: false,
      // renderHeader: () => {
      //   return (
      //     <HeaderColumn
      //       setFiltersField={setFiltersField}
      //       setOrder={setOrder}
      //       setOrderField={setOrderField}
      //       typeInput={"text"}
      //       field={"email"}
      //       place={"Email"}
      //     />
      //   );
      // },
      renderCell: (params) => {
        return (
          <Tooltip
            title={`ID Usuario: ${params.row?.causer?.usuarioID}`}
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1134C9",
                  color: "#fff",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                },
              },
              arrow: {
                sx: {
                  color: "#1134C9",
                },
              },
            }}
            arrow
          >
            <span>{params.value}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "numero_acta",
      headerName: "Acta",
      flex: 1,
      sortable: false,
      // renderHeader: () => {
      //   return (
      //     <HeaderColumn
      //       setFiltersField={setFiltersField}
      //       setOrder={setOrder}
      //       setOrderField={setOrderField}
      //       typeInput={"text"}
      //       field={"numero_acta"}
      //       place={"N° Acta"}
      //     />
      //   );
      // },
      renderCell: (params) => {
        return (
          <span
            className="text-primary fw-bold"
            onClick={() => {
              getActaDetalle(params.row.id_subject);
            }}
          >
            {params.value}
          </span>
        );
      },
    },
    {
      field: "properties",
      headerName: "Cambios",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <CambiosEvento params={params} />
          </>
        );
      },
    },
    {
      field: "created_at",
      headerName: "Fecha",
      flex: 1,
      sortable: false,
      // renderHeader: () => {
      //   return (
      //     <HeaderColumn
      //       setFiltersField={setFiltersField}
      //       setOrder={setOrder}
      //       setOrderField={setOrderField}
      //       typeInput={"text"}
      //       field={"created_at"}
      //       place={"Fecha"}
      //     />
      //   );
      // },
    },
    {
      headerName: "Acciones",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <Tooltip
            title="Ver detalle"
            arrow
            className="mx-auto"
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1134C9",
                  color: "#fff",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                },
              },
              arrow: {
                sx: {
                  color: "#1134C9",
                },
              },
            }}
          >
            <IconButton
              onClick={() => {
                getEventSelect(params.id);
              }}
            >
              <EyeIcon />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const rows = data.map((d, index) => {
    // causer: {id, usuarioID, documento, nombre, genero, celular, correo};
    // created_at: "27/06/2024 16:19:54";
    // id: 8;
    // log_name: "user";
    // subject: {id: 1, numero_acta: 1234};
    return {
      causer: d.causer,
      email: d.causer?.correoElectronico,
      created_at: d.created_at,
      id: d.id,
      log_name: d?.log_name,
      id_subject: d.subject?.id,
      numero_acta: d.subject?.numero_acta,
      properties: d.properties,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.causer?.correoElectronico)?.toString().toLowerCase().includes(value) ||
      String(d.log_name)?.toString().toLowerCase().includes(value) ||
      String(d.id_subject)?.toString().toLowerCase().includes(value) ||
      String(d.subject?.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
